import script from "./ProfileConsultant.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileConsultant.vue?vue&type=script&setup=true&lang=js"

import "./ProfileConsultant.vue?vue&type=style&index=0&id=520ee76a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520ee76a"]])

export default __exports__